import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import CreateFeed from '@/components/CreateFeed/CreateFeed.vue'


export default {
  components: {
    Sidebar,
    Navbar,
    CreateFeed
  },
  data() {
    return ({
      report_url: null,
      topics: [],
      fileName: '',
      fileError: '',
      audio_file: null,
      isRecording: false,
      selectedPortalId: null,
      selectedVisibility: 'public',
      upload_media: '',
      imagePreview: null,
      is_public: true,
      comments_off: true,
      errors: {
        report_description: null,
        audio_file: null,
      },
      isSubmitting: false,
      reports: [],
      user_details: {
        "user_role": '',
        "user_id": '',
        "first_name": '',
        "last_name": '',
      },
    });
  },
  mounted() {
this.$refs.create_feed.selectedPortalId = 123;
    this.fecthTopics();
    Promise.all([this.fetchReports()]).then(() => {
      this.$nextTick(() => {
        $('.table').DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          }
        });
      });
    });

    this.user_details = get_user_details();

  },
  computed: {
    isPublic() {
      return this.selectedVisibility === 'public';
    },
  },
  props: ['topic_id'],

  methods: {
    addNewReport(report) {
    this.reports.unshift(report); // Add to beginning
  },
    trigger_comp(){
      this.$refs.create_feed.selectedPortalId =this.selectedPortalId;
      this.$refs.create_feed.selectedTopicId=this.$route.params.topic_id;
    },
    fecthTopics() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_topics_api`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.topics = response.topics

            const topicId = this.$route.params.topic_id;

            const matchedTopic = this.topics.find(topic => topic.id == topicId);

            if (matchedTopic) {
              this.selectedPortalId = matchedTopic.portal_id;
            }
            else {
              this.selectedPortalId = null;
            }
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    filterReportsByTopic(topicId) {
      this.topic_id = topicId
      this.fetchReports(topicId);
      this.fetchExchangeHubs(topicId);
    },
    getToken() {
      return get_token();
    },

    deleteReport(report_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'DELETE',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_report_api/`,
            data: { report_id: report_id },
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: () => {
              Swal.fire(
                {
                  icon: 'success',
                  title: 'Feed deleted',
                  showConfirmButton: false,
                  timer: 2000
                }
              );
              this.reports = this.reports.filter(report => report.id !== report_id);
            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to delete the feed. Please try again.',
              });
            }
          });
        }
      });
    },
    setVisibility(isPublic) {
      this.is_public = isPublic;
    },

    resetForm() {
      this.report_name = '';
      this.report_url = '';
      this.topic = '';
      this.upload_media = null;
      this.is_public = true;
      this.errors = {};
      this.name = '';
      if (this.$refs.quillEditorRef) {
        this.$refs.quillEditorRef.setText('');
      }
      this.fileName = '';
    },

    fetchReports() {
      const topic_id = this.$route.params.topic_id


      const payload = {
        filter_values: {
          topic: topic_id

        }
      }
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/filter_reports_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (data) => {
          var status = data.status
          if (status === "success") {
            this.reports = data.data.report_data

          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

  }
};